// The preview shell explicitly opts into synthetic fixtures. Page defaults stay empty.
import { approvalsFixture } from './approvalsFixture.jsx';
import { dashboardFixture } from './dashboardFixture.js';
import { displayFixture } from './displayFixture.jsx';
import { familyFixture } from './familyFixture.js';
import { homeFixture } from './homeFixture.jsx';
import { insightsFixture } from './insightsFixture.jsx';
import { loginFixture } from './loginFixture.jsx';
import { onboardingFixture } from './onboardingFixture.jsx';
import { platformAdminFixture } from './platformAdminFixture.jsx';
import { questStudioFixture } from './questStudioFixture.jsx';
import { settingsFixture } from './settingsFixture.js';
import { todayFixture } from './todayFixture.jsx';
import { trophiesFixture } from './trophiesFixture.jsx';
import { villageFixture } from './villageFixture.jsx';
import { walletFixture } from './walletFixture.jsx';

export const pageFixtures = {
  Approvals: approvalsFixture,
  Dashboard: dashboardFixture,
  Display: displayFixture,
  Family: familyFixture,
  Home: homeFixture,
  Insights: insightsFixture,
  Login: loginFixture,
  Onboarding: onboardingFixture,
  PlatformAdmin: platformAdminFixture,
  QuestStudio: questStudioFixture,
  Settings: settingsFixture,
  Today: todayFixture,
  Trophies: trophiesFixture,
  Village: villageFixture,
  Wallet: walletFixture,
};
